
<template>
  <footer class="footer">
    <div min-height="10em" height="10em">
      <div class="ma-8">
        <div class="textwidget d-none d-sm-flex">
          <v-row>
            <v-col cols="1"></v-col>
            <v-col>
              <v-img class="mb-4" src="/assets/logo-white.svg" max-width="10em" width="10em" :alt="$t('app.logo')" />
              <p><strong>Fürstenberg Institut GmbH</strong></p>
              <p>Zentrale Hamburg</p>
              <p>Gorch-Fock-Wall 3</p>
              <p>20354 Hamburg</p><br />
              <p><a href="tel:+49040293430123" :aria-label="$t('Accessibility.contact_number')">+49 (0) 40 38 08 20-0</a></p>
              <p><a href="mailto:my@fuerstenberg-institut.de">my@fuerstenberg-institut.de</a></p>
            </v-col>
            <v-spacer />
            <v-col cols="3">
              <p><strong>{{ $t('app.links') }}</strong></p><br />
              <a target="_blank" :href="impressum">{{ $t('app.imprint') }}</a><br />
              <a target="_blank" :href="datenschutz">{{ $t('app.privacy') }}</a><br />
              <a target="_blank" :href="auslandsservicenummern">{{ $t('app.serviceNumbers') }}</a><br />
              <a target="_blank" :href="faq">{{ $t('app.faq') }}</a>
            </v-col>
          </v-row>
        </div>

        <div class="textwidget d-flex d-sm-none">

          <v-row>
            <v-col>
              <v-img class="mb-4" src="/assets/logo-white.svg" max-width="10em" width="10em" :alt="$t('app.logo')" />
              <p><strong>Fürstenberg Institut GmbH</strong></p>
              <p>Zentrale Hamburg</p>
              <p>Gorch-Fock-Wall 3</p>
              <p>20354 Hamburg</p><br />
              <p><a href="tel:+49040293430123">+49 (0) 40 38 08 20-0</a></p>
              <p><a href="mailto:my@fuerstenberg-institut.de">my@fuerstenberg-institut.de</a></p>
            </v-col>
          </v-row>
        </div>

        <div class="textwidget d-flex d-sm-none mt-8">

          <v-row>
            <v-col>
              <p><strong>{{ $t('app.links') }}</strong></p><br />
              <a target="_blank" :href="impressum">{{ $t('app.imprint') }}</a><br />
              <a target="_blank" :href="datenschutz">{{ $t('app.privacy') }}</a><br />
              <a target="_blank" :href="auslandsservicenummern">{{ $t('app.serviceNumbers') }}</a><br />
              <a target="_blank" :href="faq">{{ $t('app.faq') }}</a>
            </v-col>

          </v-row>

        </div>

        <div class="mt-4">
          <v-row align="center">
            <v-col align="center">© 2023 Fürstenberg Institut</v-col>
          </v-row>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

  data() {
    return {
      base: "https://www.fuerstenberg-institut.de/"
    }
  },

  computed: {
    faq: function () {
      return this.base + this.$i18n.locale + "/faq/";
    },
    auslandsservicenummern: function () {
      return this.base + this.$i18n.locale + "/auslandsservicenummern/";
    },
    datenschutz: function () {
      return this.base + this.$i18n.locale + "/datenschutz/";
    },
    impressum: function () {
      return this.base + this.$i18n.locale + "/impressum/";
    }
  }

}
</script>

<style scoped>

.textwidget a:hover {
  color: #EDF081
}
.textwidget a {
  -webkit-text-size-adjust: 100%;
    --page-title-display: block;
    -webkit-font-smoothing: antialiased;
    overflow-wrap: anywhere;
    text-align: left;
    font-style: inherit;
    font-family: "Nunito Sans Regular";
    font-weight: 400;
    text-transform: none;
    font-size: 1rem;
    line-height: 1.7em;
    letter-spacing: 0;
    box-sizing: inherit;
    background-color: transparent;
    transition: all .2s linear;
    text-decoration: none;
    outline: none;
    color: #FFFFFF;
}
.textwidget strong {
    color: #FFFFFF;
    overflow-wrap: anywhere;
    text-align: left;
    box-sizing: inherit;
    border: 0;
    font-style: inherit;
    margin: 0;
    outline: 0;
    padding: 0;
    vertical-align: baseline;
    font-family: "Nunito Sans Bold";
    font-weight: 700;
    text-transform: none;
    font-size: 1rem;
    line-height: 1.7em;
    letter-spacing: 0;
    margin-top: 0.9375rem;
    margin-bottom: 0;
}

.footer {
  background: linear-gradient(115deg, #1C6F62 0%, #11554A 100%);
  color: #E4E4E4;
  font-family: "Nunito Sans Regular";
  font-weight: 700;
  text-transform: none;
  font-size: 1rem;
  line-height: 1.7em;
  letter-spacing: 0;
}
</style>